var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("p", [_vm._v("Сальдо прошлого дня:")]),
        _vm._v(" "),
        _vm._l(_vm.getCurrencyBalance(_vm.balance.start), function (balance) {
          return _c("p", [
            balance.currency
              ? _c("span", [_vm._v(_vm._s(balance.currency) + ": ")])
              : _vm._e(),
            _vm._v(" "),
            _c("strong", [
              _vm._v(_vm._s(balance.balance.toLocaleString("ru-RU"))),
            ]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }